var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    class: _vm.btnClassName,
    attrs: {
      "disabled": _vm.disabled,
      "aria-label": _vm.ariaLabel,
      "aria-pressed": _vm.ariaPressed
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm.showIcon ? _c('i', {
    class: _vm.iconClassName
  }) : _vm._e(), _vm.showText ? _c('span', {
    class: _vm.textClassName
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }